<section class="">
  <div class="clearfix title-holder has-btn">
    <div class="d-flex align-items-center gap-3 mb-3">
      <div class="d-flex align-items-center gap-2">
        <h6 class="mb-0 page-title" i18n>Reviews</h6>
        <app-page-help articleId="mCsbvsEe4iQQiPDFWxVBPR" videoId="-"></app-page-help>

        <ul class="internal-module-switcher ml-3">
          <li
            class="module-item"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="Dashboard"
            i18n-matTooltip
          >
            <a routerLink="/reviews">
              <i class="cs-icon cs-icon-dashboard2 text-xl"></i>
            </a>
          </li>
          <li class="module-item" routerLinkActive="active" matTooltip="Reviews" i18n-matTooltip>
            <a routerLink="/reviews/list">
              <i class="cs-icon cs-icon-chat-star2 text-xl"></i>
            </a>
          </li>
          <li class="module-item" routerLinkActive="active" matTooltip="Bookings" i18n-matTooltip>
            <a routerLink="/reviews/bookings">
              <i class="cs-icon cs-icon-calendar-alt text-xl"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="flex-fill"></div>
      <button
        class="btn btn-secondary-warning"
        (click)="onDraftTasks()"
        *ngxPermissionsOnly="['canApproveTasks']"
        matTooltip="The tasks created from incidents and requires approval"
        i18n-matTooltip
      >
        <span class="badge badge-circle badge-warning" style="--size: 1rem">{{ (pendingTasks$ | async).length }}</span>
        <ng-container i18n>Pending Task Approval</ng-container>
      </button>
      <ng-template [ngTemplateOutlet]="automationBtn"></ng-template>
      <div dropdown [isDisabled]="1 | isReadonlyRole" class="btn-group">
        <button
          dropdownToggle
          type="button"
          class="btn btn-secondary-warning dropdown-toggle"
          i18n-matTooltip
          matTooltip="You can perform multiple actions using this button."
        >
          <span class="cs-icon cs-icon-bolt"></span> <ng-container i18n>Actions</ng-container>
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
          <li i18n-matTooltip matTooltip="Import reviews from all connected properties" matTooltipPosition="left">
            <button (click)="onImport()" type="button">
              <i class="cs-icon cs-icon-refresh"></i> <ng-container i18n>Import</ng-container>
            </button>
          </li>
          <li i18n-matTooltip matTooltip="Download reviews to CSV file" matTooltipPosition="left">
            <button (click)="onDownload()" type="button">
              <i class="cs-icon cs-icon-download" aria-hidden="true"></i>
              <ng-container i18n>Download</ng-container>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="container-box">
    <!-- input fields -->
    <div class="filters-box">
      <app-rental-select
        [inline]="true"
        [ctrl]="filtersForm.get('rentals')"
        placeholder="Rental"
        i18n-matTooltip
        i18n-placeholder
        matTooltip="Only show reviews with the selected rental."
      ></app-rental-select>
      <app-select-search
        bindValue="value"
        bindLabel="name"
        [items]="sourceOptions"
        [ctrl]="filtersForm.get('sources')"
        placeholder="Channel"
        i18n-matTooltip
        i18n-placeholder
        matTooltip="Only show reviews with the selected channel."
      ></app-select-search>
      <app-select-search
        class="w-auto"
        [multiple]="false"
        [showCloseButton]="true"
        [hasBlank]="true"
        blankLabel="All"
        bindValue="value"
        bindLabel="name"
        [items]="reviewerRolesOptions"
        [ctrl]="filtersForm.get('reviewerRole')"
        i18n-placeholder
        placeholder="Review by"
      ></app-select-search>
      <app-select-search
        bindValue="value"
        bindLabel="name"
        [multiple]="false"
        [hasBlank]="true"
        blankLabel="All"
        [items]="ratingCategoryOptions"
        [ctrl]="filtersForm.get('category')"
        placeholder="Category"
        i18n-placeholder
        i18n-matTooltip
        matTooltip="Only show reviews matching the selected category."
      ></app-select-search>
      <app-select-search
        bindValue="value"
        bindLabel="name"
        [items]="ratingValueOptions"
        [ctrl]="filtersForm.get('ratings')"
        placeholder="Ratings"
        i18n-placeholder
        i18n-matTooltip
        matTooltip="Only show reviews matching the selected ratings."
      ></app-select-search>
      <mat-form-field2 [showLabel]="false" matTooltipPosition="above">
        <app-mat-daterange-input
          placeholder="Date Range"
          i18n-matTooltip
          i18n-placeholder
          [formControl]="filtersForm.get('submitted')"
          matTooltip="Only show reviews within the selected date range"
        ></app-mat-daterange-input>
      </mat-form-field2>

      <app-form-switch
        [inline]="true"
        i18n-matTooltip
        matTooltip="Include reviews for deleted bookings"
        [formControl]="filtersForm.get('includeDeletedInquiries')"
        ><ng-container i18n>Include Deleted Bookings</ng-container></app-form-switch
      >

      <app-cancel-filters
        [isFiltering]="filtersForm | isFiltering"
        [filterControl]="filtersForm"
        [searchCom]="searchCom"
      ></app-cancel-filters>
      <button
        class="btn btn-secondary-primary"
        (click)="onRefresh()"
        i18n-matTooltip
        matTooltip="Refresh List"
        matTooltipPosition="above"
      >
        <i class="far fa-sync"></i>
      </button>
      <div class="flex-fill"></div>
      <app-table-search (search)="onSearch($event)" #searchCom></app-table-search>
    </div>
    <div class="table-holder table-responsive">
      <table class="table table-default table-striped">
        <mat-table
          #table
          matSort
          matSortActive="submittedAt"
          matSortDirection="desc"
          [dataSource]="dataSource"
          multiTemplateDataRows
        >
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
              <div (click)="onExpandRow(row)" class="p-3" *ngIf="row.response?.text">
                <i class="far" [ngClass]="row.reviewId === expandedReviewId ? 'fa-angle-down' : 'fa-angle-right'"></i>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="reviewer.name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <ng-container i18n>Review Of</ng-container></mat-header-cell
            >
            <mat-cell *matCellDef="let element" class="gap-2 py-2">
              <div class="d-flex flex-column align-items-center gap-1">
                <app-rental-image [rentalId]="element.rentalId" [circle]="true" [clickable]="true"></app-rental-image>
                <div *ngIf="element.reviewer?.role as role" class="">
                  <span
                    class="badge badge-circle badge-secondary-info"
                    *ngIf="role == 'guest'"
                    matTooltip="Review from the guest."
                    i18n-matTooltip
                    style="--size: 1.1rem"
                  >
                    <i class="fas fa-user"></i>
                  </span>
                  <span
                    class="badge badge-circle badge-secondary-success"
                    *ngIf="role == 'host'"
                    matTooltip="Review from the host."
                    i18n-matTooltip
                    style="--size: 1.1rem"
                  >
                    <i class="cs-icon cs-icon-building"></i>
                  </span>
                </div>
              </div>
              <div>
                <app-rental-name
                  [rentalId]="element.rentalId"
                  [clickable]="true"
                  class="text-semi-bold text-link"
                ></app-rental-name>
                <div
                  class="text-truncate text-link text-sm"
                  *ngIf="guestsById[element.guestId] as guest; else reviewee"
                  [matTooltip]="guest?.name"
                  (click)="onGuest(element.guestId)"
                  style="opacity: 0.7"
                >
                  {{ guest?.name }}
                </div>
                <ng-template #reviewee>
                  <div
                    class="text-truncate text-link text-sm"
                    *ngIf="element.reviewee as reviewee"
                    [matTooltip]="reviewee?.name"
                    style="opacity: 0.7"
                  >
                    {{ reviewee?.name }}
                  </div>
                </ng-template>
                <div
                  class="text-truncate text-link text-sm"
                  (click)="onBooking(element.inquiryId)"
                  *ngIf="element.checkIn"
                  style="opacity: 0.7"
                >
                  {{ element.checkIn | epochUTC : 'MMM DD, YYYY' }} -
                  {{ element.checkOut | epochUTC : 'MMM DD, YYYY' }}
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="submittedAt">
            <mat-header-cell *matHeaderCellDef mat-sort-header> <ng-container i18n>Date</ng-container></mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.submittedAt | date : 'dd - MMM - yyyy' }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="overallRating">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <ng-container i18n>Rating</ng-container></mat-header-cell
            >
            <mat-cell *matCellDef="let element">
              <app-rating
                [maxRating]="getMaxRating | call : element"
                [rating]="element.channelOverallRating"
                [showLevelColor]="true"
              ></app-rating>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="source">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <ng-container i18n>Channels</ng-container></mat-header-cell
            >
            <mat-cell *matCellDef="let element">
              <img [src]="element.source | channelIcon : false" [alt]="element.source" height="25" />
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="text">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <ng-container i18n>Review</ng-container></mat-header-cell
            >
            <mat-cell *matCellDef="let element" class="py-2">
              <div>
                <app-review-category-tags [review]="element" class="mb-2"></app-review-category-tags>
                <app-show-more [content]="element.text"></app-show-more>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="publish">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <ng-container i18n>Publish</ng-container></mat-header-cell
            >
            <mat-cell *matCellDef="let element">
              <app-form-switch
                [inline]="true"
                (valueChange)="onTogglePublish(element)"
                [checked]="element.published"
              ></app-form-switch>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef> <ng-container i18n>Action</ng-container> </mat-header-cell>
            <mat-cell *matCellDef="let element" class="py-3">
              <a
                href="javascript:;"
                class="text-info d-flex"
                *ngIf="canReply | call : element"
                (click)="onReply(element)"
                style="font-size: 35px"
              >
                <i class="cs-icon cs-icon-reply-text"></i>
              </a>
              <a
                href="javascript:;"
                class="text-primary d-flex"
                (click)="onExpandRow(element)"
                *ngIf="element.response"
                style="font-size: 40px"
              >
                <i class="cs-icon cs-icon-replied-text"></i>
              </a>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="response">
            <mat-cell *matCellDef="let review" [attr.colspan]="displayedColumns.length" class="px-0">
              <div class="border m-3 ml-5 w-100 bg-white p-3 rounded" *ngIf="expandedReviewId === review.reviewId">
                <div class="d-flex align-items-center gap-2 mb-3">
                  <app-avatar-name
                    *ngIf="review.reviewee?.name || review.reviewee?.role; let name"
                    [name]="name | titleCase"
                  ></app-avatar-name>
                  <div
                    class="text-muted"
                    *ngIf="review.response?.respondedAt || review.response?.lastChangeAt; let respondedAt"
                  >
                    {{ respondedAt | date : 'medium' }}
                  </div>
                </div>
                <div>
                  {{ review.response?.text }}
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns" class="clickable" (click)="onReview(row)"></mat-row>
          <mat-row
            *matRowDef="let row; columns: ['response']"
            [class.d-none]="row.reviewId !== expandedReviewId"
          ></mat-row>
        </mat-table>

        <mat-paginator2
          #paginator
          [length]="totalCount"
          [class.hidden]="isEmpty$ | async"
          [pageSize]="10"
          [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
          (page)="onPageChange($event)"
          [showFirstLastButtons]="true"
        >
        </mat-paginator2>

        <app-empty-table
          *ngIf="isEmpty$ | async"
          [isFiltering]="(filtersForm | isFiltering : ['includeDeletedInquiries']) || !searchCom.isEmpty"
          type="Reviews"
        ></app-empty-table>
      </table>
    </div>
  </div>

  <!-- /End Shared Content page -->
</section>

<ng-template #automationBtn>
  <button
    (click)="onAddAutomation()"
    [disabled]="1 | isReadonlyRole"
    class="btn btn-secondary-info"
    i18n-matTooltip
    matTooltip="Define rules to create your reviews automatically"
  >
    <span class="cs-icon cs-icon-automations"></span>
    <ng-container i18n>Automation</ng-container>
  </button>
</ng-template>

<ng-template #addBtn>
  <button
    (click)="onAddChannel()"
    [disabled]="1 | isReadonlyRole"
    class="btn btn-secondary-info"
    matTooltip="Manually create a channel"
  >
    <span class="cs-icon cs-icon-plug"></span>
    <ng-container i18n>Connect Channel</ng-container>
  </button>
</ng-template>

<app-setup-layer [loading]="isLoading" *ngIf="isReviewEmpty">
  <img src="/assets/images/empty_images/reviews.png" alt="" style="width: 360px" />
  <h6 i18n>Optimize Your Listing with Insightful Guest Reviews!</h6>
  <ol class="w-100" style="max-width: 600px">
    <li>
      <div>
        <b i18n>Overview:</b>
        <ng-container i18n>Access a comprehensive view of Airbnb reviews received for your listings.</ng-container>
      </div>
    </li>
    <li>
      <div>
        <b i18n>Review Count:</b>
        <ng-container i18n
          >At the top, see the total number of guest reviews. Filter reviews by Airbnb to streamline your
          focus.</ng-container
        >
      </div>
    </li>
    <li>
      <div>
        <b i18n>Recent Reviews:</b> <ng-container i18n
          >Browse the latest guest reviews and ratings, displayed first. View and manage your responses directly from
          this section.</ng-container
        >
      </div>
    </li>
    <li>
      <div>
        <b i18n>Review Filters:</b> <ng-container i18n
          >Easily filter reviews by specific listings to better manage your responses and insights.</ng-container
        >
      </div>
    </li>
    <li>
      <div>
        <b i18n>Unreplied Reviews:</b> <ng-container i18n
          >Quickly spot and reply to reviews awaiting your response right from the dashboard.</ng-container
        >
      </div>
    </li>
    <li>
      <div>
        <b i18n>Ratings Distribution:</b> <ng-container i18n
          >Explore the median ratings across categories like Accuracy, Checkin, Cleanliness, and more, visualized with a
          pie chart for overall ratings.</ng-container
        >
      </div>
    </li>
    <li>
      <div>
        <b i18n>Monthly Breakdown:</b>
        <ng-container i18n
          >Review the monthly review trends with a bar chart, highlighting the range from lowest to highest
          ratings.</ng-container
        >
      </div>
    </li>
  </ol>
  <div class="d-flex align-items-center justify-content-center gap-3">
    <button class="btn btn-secondary-primary" openArticleId="reviews" [category]="true" i18n>Learn More</button>
    <ng-template [ngTemplateOutlet]="automationBtn"></ng-template>
  </div>
</app-setup-layer>
